import { i18n as _i18n } from '@lingui/core'
import type { I18n as _I18n } from '@lingui/core'

export { default as shippingKindLabel } from './labels/shipping-kind-label'
export * from './labels/product-kind-label'
export * from './appTypeLocale'

export interface I18n extends _I18n {
  currency?: string
}

export const i18n: I18n = Object.assign(_i18n, { currency: undefined })

export function setCurrency(currency?: string) {
  i18n.currency = currency || 'EUR'
}
